/**
 * Created by jacky on 5/20/16.
 * @flow
 * @providesModule Login
 */

import React, { Component } from "react";
import {findDOMNode} from "react-dom";
import CSSTransition from "react-addons-css-transition-group";

import "./login.scss";
import type {EventType, QueryObjType, ProcessingStatusType, WorkspaceInfoType } from "../../../lib/query";
import {query} from "../../../lib/query";
import _ from "../../../constants";
import { escHandler } from '../../../lib/utils';
import { GA, MP } from '../../../lib/analytics';
declare var contentPool;
declare var contentId;

type SigninData = {
    email: string;
}

type LoginPropsType = {
    projectName: string;
    contentPool: string;
    contentId: string;
    onEsc: () => void;
}

type LoginStateType = {
    processing?: 'dataQuery' | ProcessingStatusType;
    counter: number;
    workspaces?: Array<WorkspaceInfoType>;
    q?: QueryObjType;
    sessionKey?: string;
    failReason?: string;
    data?: SigninData;
}

const initialState: LoginStateType = {
    processing: 'dataQuery',
    counter: 0,
    failReason: void 0
}

let timeoutHandler: ?number;

export default class Login extends React.Component {
    props: LoginPropsType;
    state: LoginStateType = initialState;
    _escHandler: () => void;
    _signinData;

    componentDidMount() {
        findDOMNode(this.refs['bndUserEmail']).focus();
        this._escHandler = escHandler(
            this.props.onEsc,
            () => GA({category: 'Acquire', action: 'FillLogin'})
        );
    }

    componentWillUnmount() {
        this._escHandler();
    }

    _processingMessaging = (r: EventType, q: QueryObjType) => {
        if (timeoutHandler) {
            clearInterval(timeoutHandler);
            timeoutHandler = null;
        }
        switch (r.status) {
            case 'SignInFailed':
            case 'ContentCreationFailed':
                GA({category: 'Acquire', action: 'LoginError', value: r.status});
                this.setState({processing: r.status, failReason: (r: any).data});
                q.close();
                break;
            case 'SelectWorkspace':
                this.setState({processing: r.status, workspaces: r.workspaces, sessionKey: r.sessionKey, q: q});
                break;
            case 'SignedIn':
                GA({category: 'Acquire', action: 'LoginWithContent', value: `${contentPool}/${contentId}`});
                MP('ST Login', `${contentPool}/${contentId}`);
            case 'SignInInitiated':
            case 'CreatingContent':
            case 'ContentCreated':
            case 'GoToURL':
                this.setState({processing: r.status, counter: Math.floor(++this.state.counter)});
                if (r.status == 'GoToURL') {
                    q.close();
                    timeoutHandler && clearInterval(timeoutHandler);
                    setTimeout(() => {
                        window.location.assign((r: any).url);
                    }, 1000);
                } else if (!timeoutHandler) {
                    timeoutHandler = setInterval(this._processingTick, 250);
                }
                break;
        }
    }

    _processingTick = () => {
        this.setState({
            counter: this.state.counter + 0.01
        })
    }

    onFormSubmit (ev: any) {
        ev.preventDefault();
        this.setState(initialState);
        setTimeout(() => {
            query(this._processingMessaging)
                .then((p: QueryObjType) => {
                    return p.send({
                        command: 'SignIn',
                        data: this._signinData = {
                            email: findDOMNode(this.refs['bndUserEmail']).value,
                            password: findDOMNode(this.refs['bndUserPassword']).value,
                            coupon: '',
                            contentPool: this.props.contentPool,
                            contentId: this.props.contentId
                        }
                    })
                })
                .catch(e => {
                    console.error(e);
                })
        })
    }

    _relogin = () => {
        const { sessionKey = '', q } = this.state;
        (q: any).close();

        this.setState({
            ...initialState,
            processing: 'SignInInitiated',
            counter: 0
        });

        setTimeout(() => {
            query(this._processingMessaging)
                .then((p: QueryObjType) => {
                    return p.send({
                        command: 'SignIn',
                        data: this._signinData
                    })
                })
                .catch(e => {
                    console.error(e);
                })
        })
    }

    _workspaceSelected = (id: string) => {
        const { sessionKey = '', q } = this.state;
        q && q.send({
            command: 'CreateContent',
            data: {
                sessionKey: sessionKey,
                workspaceId: id,
                contentPool: this.props.contentPool,
                contentId: this.props.contentId
            }
        });
    }

    render () {
        const { processing: p, failReason, data: stored = {} } = this.state;
        const { email } = this._signinData || {email: ''};
        let failReasonMessage;
        switch(failReason) {
            case 'UserNotFound':
                failReasonMessage = 'Such user is not found';
                break;
            case 'NotConfirmed':
                failReasonMessage = 'User was not confirmed yet';
                break;
            case 'WrongPassword':
                failReasonMessage = 'Wrong password or email';
                break;
            case 'BadInput':
            case 'GeneralError':
                failReasonMessage = 'Something bad is happend on server side, try again later';
                break;
            case 'FAIL':
                switch(p) {
                    case 'ContentCreationFailed':
                        failReasonMessage = 'Error while creating content. Oops...'
                        break;
                }
        }

        let r;
        switch (true) {
            case p == 'dataQuery' || !!failReason:
                r = (
                    <div>
                        <h1>
                            <span>{this.props.projectName.trim()}</span>
                            <span className="clsSmaller">Get this project plan for FREE</span>
                        </h1>
                        <div className="clsPopupNote">
                            <p>This How to guide has a built-in interactive project plan that you can execute in Casual &ndash; online project management tool.</p>
                        </div>
                        <form onSubmit={e => this.onFormSubmit(e)}>
                            <input ref="bndUserEmail" required={true} type="email" defaultValue={email} placeholder="Your Email Address" />
                            <input ref="bndUserPassword" required={true} type="password" placeholder="Password" />
                            {failReason
                                ? (
                                    <div className="clsErrorMessage">{failReasonMessage}</div>
                                )
                                : null
                            }
                            <button type="submit">GET STARTED</button>
                            <a href={signupConfig.app + 'guest/forgot-password'} target="_blank">forgot password?</a>
                        </form>
                    </div>
                )
                break;
            case p == 'GoToURL':
                r = (
                    <div>
                        <h1>Done!</h1>
                        <div className="clsPopupNote">
                            We have created a content for you.<br />
                            You'll see it in a moment...
                        </div>
                    </div>
                );
                break;
            case p == 'SelectWorkspace':
                const { workspaces: w = []} = this.state;
                if (w.filter(v => v.active).length == 0) {
                    r = (
                        <div>
                            <h1>Oops, it seems that your trial or subscription period is over.</h1>
                            <div className="clsPopupNote">
                                <p><strong>No worries, as you can request a new trial!</strong></p>
                                <p>Please <a href="https://app.casual.pm" target="_blank" rel="noopener">log into Casual.pm</a>, and follow the instructions. Then come back and you'll be able to grab your content without any obstacles.</p>
                            </div>
                            <button className="clsGreen" onClick={this._relogin}>I have unlocked new trial and<br /> ready to get the content!</button>
                        </div>
                    )
                } else {
                    r = (
                        <div>
                            <h1>Select Workspace</h1>
                            <div className="clsPopupNote">
                                You have multiple workspaces. Select one where content will be created:
                                <ul className="clsWorkspaceSelector">
                                    {w.map(v => (
                                        <li key={v.id} className={!v.active ? 'clsDisabled' : ''} onClick={() => v.active ? this._workspaceSelected(v.id) : false}>{v.name}{!v.active ? '(inactive)' : null}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )
                }
                break;
            default:
                r = (
                    <div>
                        <h1>Processing login...</h1>
                        <div className="clsProgressBar">
                            <div className="clsProgressBarBody" style={{width: (this.state: any).counter * 20 + '%'}} />
                        </div>
                    </div>
                )
                break;
        }
        return (
            <CSSTransition
                transitionName="clsDialogAnimation"
                transitionAppear={true}
                transitionEnterTimeout={300}
                transitionAppearTimeout={300}
                transitionLeaveTimeout={300}>
                <div className="clsPopup clsLogin">
                    {r}
                </div>
            </CSSTransition>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialogs/Login/login.jsx